module.exports = __webpack_public_path__ + "static/media/pending-actions.b08ab867.svg";